<template>
  <div>
    <div v-show="selectable">
      <b-form-checkbox class="pull-right" @change="toggleSelectAll()">Select all</b-form-checkbox>
    </div>
    <b-table striped
             :items="opportunities"
             :fields="fields"
             :filter="filter"
             :sort-by="sortBy"
             :per-page="perPage"
             :current-page="currentPage"
             @filtered="onFiltered"
             show-empty
             responsive
             small>
      <template slot="opportunityType" slot-scope="data">
        {{ data.item.opportunityType ? data.item.opportunityType.name : "" }}
      </template>
      <template slot="opportunityCategory" slot-scope="data">
        {{ data.item.opportunityCategory.name }}
      </template>
      <template slot="translationalTeam" slot-scope="data">
        {{ data.item.translationalTeam ? data.item.translationalTeam.name : "" }}
      </template>
      <template slot="site" slot-scope="data">
        {{ data.item.site.name }}
      </template>
      
      <template slot="opportunityId" slot-scope="data">

<router-link target="_blank" :to="{ name: 'opportunity', params: {opportunityId: data.item.opportunityId } }">{{ data.item.opportunityId }}</router-link>

      </template>

      <template slot="term" slot-scope="data">
        {{ data.item.term.description }}
      </template>
      <template slot="description" slot-scope="data">
        {{ (data.item.description && data.item.description.length) | trueOrFalse }}
      </template>
      <template slot="opportunityAreaOfInterests" slot-scope="data">
        {{ data.item.opportunityAreaOfInterests.length | trueOrFalse }}
      </template>
      <template slot="published" slot-scope="data">
        {{ data.item.published| trueOrFalse }}
      </template>
      <template slot="details" slot-scope="data">
        <router-link :to="{ name: 'opportunity', params: {opportunityId: data.item.opportunityId } }">Details</router-link>
      </template>
      <template slot="select" slot-scope="data">
        <b-form-checkbox :value="data.item" v-model="selectedOpportunities"></b-form-checkbox>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />

    <b-button class="btn-primary pull-right save-opportunity-button"
              v-if="selectable"
              @click="$emit('saveChanges', selectedOpportunities)"
              :disabled="!selectedOpportunities.length || !canSave">
      Save
    </b-button>
  </div>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fields: [
        { key: "name", label: "Name / Title", sortable: true },
        { key: "opportunityCategory", label: "Category", sortable: true },
        { key: "translationalTeam" },
        { key: "site", sortable: true },

{ key: "opportunityId", label: "ID", sortable: true },

        { key: "term", label: "Semester", sortable: true },
        { key: "description", label: "Has Description", sortable: true },
        {
          key: "opportunityAreaOfInterests",
          label: "Has Areas of Interest",
          sortable: true
        },
        {
          key: "published",
          sortable: true
        },
        { key: "opportunityType", label: "Type", sortable: true },
        { key: "details", label: "" }
      ],
      sortBy: "opportunityCategory",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      selectedOpportunities: [],
      selectAll: false
    };
  },

  props: {
    opportunities: {
      type: Array,
      required: true
    },
    filter: {
      type: String,
      default: ""
    },
    selectable: {
      type: Boolean
    },
    publish: {
      type: Boolean
    },
    canSave: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    hasBeenChecked(opportunity) {
      var found = _.find(this.selectedOpportunities, function(
        selectedOpportunity
      ) {
        return selectedOpportunity.opportunityId === opportunity.opportunityId;
      });
      if (!found) {
        return false;
      }
      return true;
    },

    togglePublished(opportunity) {
      // only toggle publish if the publish prop has been set
      if (this.publish) {
        opportunity.published = !opportunity.published;
      }
    },

    toggleSelectAll() {
      var that = this;
      this.selectAll = !this.selectAll;
      if (this.selectAll == false) {
        // remove all
        that.selectedOpportunities = [];
      } else {
        // remove all first to clear any previously selected
        that.selectedOpportunities = [];
        // add all
        that.selectedOpportunities = [];
        _.forEach(this.opportunities, function(opp) {
          that.selectedOpportunities.push(opp);
        });
      }
    }
  },

  created() {
    // if selectable prop is passed, extra column is added
    if (this.selectable) {
      this.fields.push({ key: "select", label: "" });
    }
  }
};
</script>

<style scoped>
.save-opportunity-button {
  margin-bottom: 10px;
}
</style>
